module.exports = __webpack_public_path__ + "static/media/us.c99f2b91.svg";